import React, { useId } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}
export function Input({
  label,
  error,
  helperText,
  className = '',
  id,
  required,
  ...props
}: InputProps) {
  const inputId = id || useId();
  return <div className="w-full" data-id="element-184">
      {label && <label htmlFor={inputId} className="block text-sm font-normal text-[#3e3e3c] mb-1" data-id="element-185">
          {label} {required && <span className="text-[#ba0517]" data-id="element-186">*</span>}
        </label>}
      <input id={inputId} className={`
          w-full h-9 px-3 rounded-[4px] border bg-white text-[#080707] text-sm
          transition-shadow focus:outline-none focus:ring-1 focus:ring-[#0176d3] focus:border-[#0176d3]
          ${error ? 'border-[#ba0517] focus:ring-[#ba0517] focus:border-[#ba0517]' : 'border-[#dddbda]'}
          disabled:bg-[#f3f2f2] disabled:text-[#3e3e3c] disabled:border-[#c9c7c5]
          ${className}
        `} {...props} data-id="element-187" />
      {error && <p className="mt-1 text-xs text-[#ba0517]" data-id="element-188">{error}</p>}
      {helperText && !error && <p className="mt-1 text-xs text-[#3e3e3c]" data-id="element-189">{helperText}</p>}
    </div>;
}